import './Frontend.css';
import VerticalStepper from '../UI/VerticalStepper';
import { useEffect, useState } from 'react';
import HomeNavbar from '../UI/HomeNavbar';
import { useUserAuth } from '../../context/UserAuthContext';
import LoadingModal from '../UI/LoadingModal';
import ErrorModal from '../UI/ErrorModal';

const ML = ({saveProgressData, getProgressData}) => {
    const IntroSteps = [
        {
            label: 'What is Machine Learning?',
            description: `Get an overview of the concepts and applications of machine learning.`,
            link: 'https://youtu.be/cfSDvPlFFVQ?si=NspKX8ByMilzkryk'
        },
        {
            label: 'Types of Machine Learning',
            description: `Learn about supervised, unsupervised, and reinforcement learning.`,
            link: 'https://youtu.be/olFxW7kdtP8?si=mbKeaLqbC3FH9BTZ'
        },
        {
            label: 'Machine Learning Algorithms',
            description: `Explore common algorithms like linear regression, decision trees, and more.`,
            link: 'https://youtu.be/I7NrVwm3apg?si=hZEaEjGcCyo0f61B'
        }
    ];

    const PreProcSteps = [
        {
            label: 'Data Cleaning',
            description: `Learn techniques to handle missing data and outliers.`,
            link: 'https://youtu.be/I7NrVwm3apg?si=hZEaEjGcCyo0f61B'
        },
        {
            label: 'Feature Engineering',
            description: `Discover methods to extract and create relevant features.`,
            link: 'https://youtu.be/pYVScuY-GPk?si=F2LMMLtHqAXKDxa9'
        },
        {
            label: 'Data Normalization',
            description: `Understand scaling and normalization of data for accurate models.`,
            link: 'https://youtu.be/bqhQ2LWBheQ?si=vcx5C5VLTb5MNWAT'
        }
    ];

    const ModelTrainSteps = [
        {
            label: 'Training and Testing',
            description: `Split data, train models, and evaluate performance.`,
            link: 'https://youtu.be/fwY9Qv96DJY?si=lFRhnoPmlDICn95A'
        },
        {
            label: 'Cross-Validation',
            description: `Learn about cross-validation techniques for robust evaluations.`,
            link: 'https://youtu.be/fSytzGwwBVw?si=5Ad7deX4NzHdRrSE'
        },
        {
            label: 'Hyperparameter Tuning',
            description: `Optimize model performance by tuning hyperparameters.`,
            link: 'https://youtu.be/HdlDYng8g9s?si=07N02avSPOKrVN8i'
        }
    ];

    const SupervisedLearningSteps = [
        {
            label: 'Classification',
            description: `Understand classification algorithms and applications.`,
            link: 'https://youtu.be/pXdum128xww?si=Blb9p-I3wSogCD3o'
        },
        {
            label: 'Regression',
            description: `Explore regression techniques for predicting continuous values.`,
            link: 'https://youtu.be/OCwZyYH14uw?si=0fAurcxSScECMrsf'
        },
        {
            label: 'Ensemble Learning',
            description: `Learn about ensemble methods like random forests and boosting.`,
            link: 'https://youtu.be/WtWxOhhZWX0?si=0HDi9NJANOO12EI0'
        }
    ];

    const UnsupervisedLearningSteps = [
        {
            label: 'Clustering',
            description: `Discover clustering algorithms for grouping data points.`,
            link: 'https://youtu.be/1XqG0kaJVHY?si=6nw5kMZAzT1ONy9E'
        },
        {
            label: 'Dimensionality Reduction',
            description: `Learn techniques to reduce the complexity of high-dimensional data.`,
            link: 'https://youtu.be/3uxOyk-SczU?si=o0FXZfsgS8pg4YOP'
        },
        {
            label: 'Anomaly Detection',
            description: `Explore methods to identify unusual patterns in data.`,
            link: 'https://www.youtube.com/live/2K3ScZp1dXQ?si=9ZTzsA3A9zOQU3Av'
        }
    ];

    const DeepLearningSteps = [
        {
            label: 'Neural Networks',
            description: `Understand the basics of neural networks and their components.`,
            link: 'https://youtu.be/aircAruvnKk?si=-TrECZbdmNaWlscN'
        },
        {
            label: 'Convolutional Neural Networks (CNNs)',
            description: `Learn about CNNs for image recognition and processing.`,
            link: 'https://youtu.be/zfiSAzpy9NM?si=XeNi-rvBKkPMW9IC'
        },
        {
            label: 'Recurrent Neural Networks (RNNs)',
            description: `Explore RNNs for sequential data analysis and natural language processing.`,
            link: 'https://youtu.be/Y2wfIKQyd1I?si=yg1QMwdn51Y5HMaE'
        }
    ];

    const DeploymentSteps = [
        {
            label: 'Model Deployment Basics',
            description: `Learn about deploying models for real-world applications.`,
            link: 'https://youtu.be/tSiS15ubQFQ?si=Wr1r-ZcNpoQ2JNQc'
        },
        {
            label: 'Web APIs for Models',
            description: `Build and expose machine learning models as web APIs.`,
            link: 'https://youtu.be/C82lT9cWQiA?si=Bm_j-zFbJigDoS1P'
        },
        {
            label: 'Cloud Platforms for Deployment',
            description: `Explore cloud platforms like AWS and GCP for model deployment.`,
            link: 'https://youtu.be/I9XbY9WHDCM?si=200AkLmjgky5aWYX'
        }
    ];

    // Totol Steps = 21

    // The total Progress is for progress graph for every user whereas individual step progress is for saving the progress in DB
    const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);

    // Introduction to ML Progress
    const [introCompletedSteps, setIntroCompletedSteps] = useState(0);

    const handleIntroStepComplete = () => {
        setIntroCompletedSteps(introCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
        console.log(introCompletedSteps);
    };

    const handleIntroStepBack = () => {
        setIntroCompletedSteps(introCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Data Pre Processing Progress
    const [preprocCompletedSteps, setPreprocCompletedSteps] = useState(0);

    const handlePreprocStepComplete = () => {
        setPreprocCompletedSteps(preprocCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handlePreprocStepBack = () => {
        setPreprocCompletedSteps(preprocCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Model Building Progress
    const [modelCompletedSteps, setModelCompletedSteps] = useState(0);

    const handleModelStepComplete = () => {
        setModelCompletedSteps(modelCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleModelStepBack = () => {
        setModelCompletedSteps(modelCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Supervised Learning Progress
    const [supLearnCompletedSteps, setSupLearnCompletedSteps] = useState(0);

    const handleSupLearnStepComplete = () => {
        setSupLearnCompletedSteps(supLearnCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleSupLearnStepBack = () => {
        setSupLearnCompletedSteps(supLearnCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Unsupervised Learning Progress
    const [unsupLearnCompletedSteps, setUnsupLearnCompletedSteps] = useState(0);

    const handleUnsupLearnStepComplete = () => {
        setUnsupLearnCompletedSteps(unsupLearnCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleUnsupLearnStepBack = () => {
        setUnsupLearnCompletedSteps(unsupLearnCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Deep Learning Progress
    const [deepLearnCompletedSteps, setDeepLearnCompletedSteps] = useState(0);

    const handleDeepLearnStepComplete = () => {
        setDeepLearnCompletedSteps(deepLearnCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleDeepLearnStepBack = () => {
        setDeepLearnCompletedSteps(deepLearnCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Deployment Progress
    const [deployCompletedSteps, setDeployCompletedSteps] = useState(0);

    const handleDeployStepComplete = () => {
        setDeployCompletedSteps(deployCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleDeployStepBack = () => {
        setDeployCompletedSteps(deployCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Firestore data
    useEffect(() =>{
        saveProgressData({
            totalSteps: 21,
            totalCompletedSteps: totalCompletedSteps,
            introCompletedSteps: introCompletedSteps,
            preprocCompletedSteps: preprocCompletedSteps,
            modelCompletedSteps: modelCompletedSteps,
            supLearnCompletedSteps: supLearnCompletedSteps,
            unsupLearnCompletedSteps: unsupLearnCompletedSteps,
            deepLearnCompletedSteps: deepLearnCompletedSteps,
            deployCompletedSteps: deployCompletedSteps
        });
    }, [totalCompletedSteps, introCompletedSteps, preprocCompletedSteps, modelCompletedSteps, supLearnCompletedSteps, unsupLearnCompletedSteps, deepLearnCompletedSteps, deployCompletedSteps]);

    const {currentUser, isLoading} = useUserAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const asyncFunc = async() => {
            const progressData = await getProgressData();
            console.log(progressData);
            if (progressData) {
                setTotalCompletedSteps(progressData.totalCompletedSteps);
                setIntroCompletedSteps(progressData.introCompletedSteps);
                setPreprocCompletedSteps(progressData.preprocCompletedSteps);
                setModelCompletedSteps(progressData.modelCompletedSteps);
                setSupLearnCompletedSteps(progressData.supLearnCompletedSteps);
                setUnsupLearnCompletedSteps(progressData.unsupLearnCompletedSteps);
                setDeepLearnCompletedSteps(progressData.deepLearnCompletedSteps);
                setDeployCompletedSteps(progressData.deployCompletedSteps);
            }
        };
        asyncFunc();
        if(!currentUser && !isLoading){
            setError('Error');
        }
        else{
            setError('');
        }
    }, [currentUser]);

    return (
        <body>
            <HomeNavbar/>
            <h1 className='tech-main-title'>Machine Learning</h1>
            <div className='web-container'>
                <div className='html-container'>
                    <h1 className='tech-title'>Introduction to Machine Learning</h1>
                    <VerticalStepper steps={IntroSteps}  onStepComplete={handleIntroStepComplete} onStepBack={handleIntroStepBack} stepsCompleted={introCompletedSteps}/>
                </div>
                <div className='js-container'>
                    <h1 className='tech-title'>Data Preprocessing</h1>
                    <VerticalStepper steps={PreProcSteps}  onStepComplete={handlePreprocStepComplete} onStepBack={handlePreprocStepBack} stepsCompleted={preprocCompletedSteps}/>
                </div>
                <div className='react-container'>
                    <h1 className='tech-title'>Model Building and Evaluation</h1>
                    <VerticalStepper steps={ModelTrainSteps}  onStepComplete={handleModelStepComplete} onStepBack={handleModelStepBack} stepsCompleted={modelCompletedSteps}/>
                </div>
                <div className='api-container'>
                    <h1 className='tech-title'>Supervised Learning</h1>
                    <VerticalStepper steps={SupervisedLearningSteps}  onStepComplete={handleSupLearnStepComplete} onStepBack={handleSupLearnStepBack} stepsCompleted={supLearnCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Unsupervised Learning</h1>
                    <VerticalStepper steps={UnsupervisedLearningSteps}  onStepComplete={handleUnsupLearnStepComplete} onStepBack={handleUnsupLearnStepBack} stepsCompleted={unsupLearnCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Deep Learning</h1>
                    <VerticalStepper steps={DeepLearningSteps}  onStepComplete={handleDeepLearnStepComplete} onStepBack={handleDeepLearnStepBack} stepsCompleted={deepLearnCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Deploying Machine Learning Models</h1>
                    <VerticalStepper steps={DeploymentSteps}  onStepComplete={handleDeployStepComplete} onStepBack={handleDeployStepBack} stepsCompleted={deployCompletedSteps}/>
                </div>
            </div>
            <ErrorModal errorMsg='Plz Login To Save Your Progress!' isError={error} />
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </body>
    );
}

export default ML;